import * as React from 'react';
import './TabPage.css';
import { space, color, flexWrap, minWidth, maxWidth, alignItems, flexDirection, justifyContent } from 'styled-system';
import styled from 'styled-components';
import { theme } from '../../theme';

const TabContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  padding: 0 20px;
  flex-wrap: wrap;
  flex-direction: row;
  box-sizing: border-box;
  box-shadow: 0 4px 4px -4px rgba(50, 50, 93, 0.3);
`;

const Tab = styled.div`
  flex: 1;
  ${space};
  ${color};
  ${flexWrap};
  ${minWidth};
  ${maxWidth};
  ${alignItems};
  display: flex;
  ${flexDirection};
  ${justifyContent};
  position: relative;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  &.active-tab:after {
    left: 0;
    right: 0;
    bottom: 0;
    content: '';
    height: 3px;
    position: absolute;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    background-color: ${theme.colors.putty};
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

type State = {
  activeTab: number;
};

type Props = {
  tabs: string[];
  onTabChange: (index: number) => void;
  children: React.ReactNode[];
};

class TabPage extends React.Component<Props, State> {
  state = {
    activeTab: 0,
  };

  setActiveTab(index: number) {
    this.setState({ activeTab: index });
    this.props.onTabChange(index);
  }

  render() {
    const { tabs, children } = this.props;
    const { activeTab } = this.state;
    return (
      <>
        <TabContainer>
          {tabs.map((tab, index) => {
            return tab !== '' ? (
              <Tab
                className={(index === activeTab && 'active-tab') || ''}
                key={index}
                onClick={() => this.setActiveTab(index)}
              >
                {tab === '' ? <></> : <>{tab}</>}
              </Tab>
            ) : (
              <></>
            );
          })}
        </TabContainer>
        {children && children.length && children[activeTab]}
      </>
    );
  }
}

export default TabPage;



// WEBPACK FOOTER //
// ./src/components/TabPage/TabPage.tsx